export const LookupEntity = {
  Patient: 'Patient',
  Practitioner: 'Practitioner',
  User: 'User',
  Location: 'Location',
  PractitionerLocation: 'PractitionerLocation',
  AppointmentType: 'AppointmentType',
  Medicine: 'Medicine',
  Diagnosis: 'Diagnosis',
  Pharmacy: 'Pharmacy',
  LabTest: 'LabTest',
  Role: 'Role',
  IdentityType: 'IdentityType',
  CarePlanType: 'CarePlanType',
  TaskCategory: 'TaskCategory',
  Staff: 'Staff',
  PatientEducationCategory: 'PatientEducationCategory',
  Questionnaire: 'Questionnaire',
} as const;
